import { useState } from 'react';
import '../../styles/resourceStyle.css';
import './installer/downloads.css';
import { Accordion } from 'react-bootstrap';
import {faqs, nxWitnessPdfGuide, milestonePdfGuide, avigilonPdfGuide, wisenetPdfGuide, dwSpectrumPdfGuide, MFAGuide, businessLink, business} from "../../config/index.js"; 
import SmallIcon from "../../images/SmallIcon.png";
import SideBarSmallScreen from '../SideBarSmallScreen.js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload, faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { hmLink } from '../../config/index.js';
import { webURL } from '../../config/index.js';

// VMS logos
import vms_milestone from '../../images/vms_milestone.png';
import vms_nx from '../../images/vms_nx.png';
import vms_avigilon from '../../images/vms_avigilon.png';
import vms_wisenet from '../../images/vms_wisenet.png';
import vms_dw from '../../images/vms_dw.png';

// Import generic components
import Input from '../../generic_components/Input/Input.jsx';
import Footer from '../../generic_components/Footer/Footer.jsx';
import Tooltip from '../../generic_components/Tooltip/Tooltip.jsx';
import Select from '../../generic_components/Select/Select.jsx';

const DownloadsFaq = () => {
    const isSmallScreen = window.innerWidth < 600;
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedVMSGuide, setSelectedVMSGuide] = useState(0); // Default to Nx Witness (index 0)
    // const [activeTooltip, setActiveTooltip] = useState(null);

    // Updated quickLinks without the PDF Guide (moved to downloads section)
    const quickLinks = [
        {
            category: 'link',
            links: 
                [
                    {
                        href: businessLink,
                        label: `${business} Website`,
                        description: "Visit the main AOL portal for news, email, and services",
                        icon: "🌐"
                    },
                ]
        },
        {
            category: 'download',
            links: [
                {
                    href: MFAGuide,
                    label: "MFA Setup Guide",
                    description: "Setup guide for multi-factor authentication",
                    icon: "⬇️" 
                },
                {
                    href: "/#installer/faq",
                    label: "Interactive Installer Guide",
                    description: "Step-by-step visual guide for setup",
                    icon: "🧭" 
                },
            ]
        },
        {
            category: 'email',
            links:
                [
                    {
                        href: "/#contact-us/support",
                        label: "Tech Support",
                        description: "Get technical assistance and troubleshooting help",
                        icon: "🛠️"
                    },
                    {
                        href: "/#contact-us/sales",
                        label: "Sales Inquiry",
                        description: "Connect with our sales team for business solutions",
                        icon: "💼"
                    },
                ]
        },
    ];

    // Tooltip content for each installer type
    const tooltipContent = {
        ubuntu: {
            title: "Ubuntu Installation Tips",
            instructions: [
                "Click the button 'Download for Ubuntu' to download the installer",
                "Once downloaded, Right-click the ronin.deb file",
                "Open with 'Other Application' and select 'Software Install'",
                "Click the 'Install' link in the Software Install window to begin installation",               
            ]
        },
        windows: {
            title: "Windows Installation Tips",
            instructions: [
                "Click the button 'Download for Windows' to download the installer",
                "Once downloaded, double-click the ronin.exe file",
                "Follow the on-screen instructions to complete the installation",               
            ]
        },
        vmsGuides: {
            title: "Installation Guides",
            instructions: [
                "Choose the appropriate guide for your VMS platform",
                "Each guide contains step-by-step installation instructions",                
                "Configuration and troubleshooting tips included",               
                "Compatible with Nx Witness, Milestone, and Avigilon VMS systems",          
            ]
        }
    };

    // VMS Guides data
    const vmsGuides = [
        {
            name: 'Nx Witness',
            href: nxWitnessPdfGuide,                   
            logo: vms_nx
        },       
        {
            name: 'Milestone',
            href: milestonePdfGuide,                    
            logo: vms_milestone
        },
        {
            name: 'Avigilon',
            href: avigilonPdfGuide,                    
            logo: vms_avigilon
        },
        {
            name: 'Wisenet Wave',
            href: wisenetPdfGuide,                  
            logo: vms_wisenet
        },
        {   
            name: 'DW Spectrum',
            href: dwSpectrumPdfGuide,                    
            logo: vms_dw    
        }
    ];

    // Download packages data
    const downloadPackages = [
        {
            id: 'ubuntu',
            title: 'Ubuntu Installer',
            description: 'For Ubuntu systems',
            version: '7.0',
            size: '3 KB',
            format: '.deb package',
            icon_class: "fa-brands fa-ubuntu",
            color: 'bg-orange-500',
            hoverColor: 'hover:bg-orange-600',
            href: `${hmLink}/ronin.deb`,
            buttonText: 'Download for Ubuntu',
            supportedVMS: ['Nx Witness']
        },
        {
            id: 'windows',
            title: 'Windows Installer',
            description: 'For Windows Servers',
            version: '7.0',
            size: '38.4 MB',
            format: '.exe installer',
            icon_class: "fa-brands fa-windows",
            color: 'bg-blue-500',
            hoverColor: 'hover:bg-blue-600',
            href: `${hmLink}/ronin_installer.zip`,
            buttonText: 'Download for Windows',
            supportedVMS: ['Nx Witness', 'Milestone', 'Avigilon']
        },
        {
            id: 'vmsGuides',
            title: 'Installation Guides',
            description: 'Guides for the supported VMS',
            version: '7.0',
            format: 'PDF documents',
            icon_class: "fa-solid fa-file-pdf",
            color: 'bg-indigo-500',
            hoverColor: 'hover:bg-indigo-600',
            useDropdown: true
        }
    ];

    const handleSearchTerm = (e) => {
        setSearchTerm(e.target.value);
    }

    const handleVMSGuideChange = (e) => {
        setSelectedVMSGuide(parseInt(e.target.value));
    }

    // Prepare options for Select component
    const vmsGuideOptions = vmsGuides.map((guide, idx) => ({
        value: idx,
        label: guide.name
    }));

    // Filter out questions based on search term(s)
    const filteredFAQs = faqs.filter((faq) => faq.question.toLowerCase().includes(searchTerm.toLowerCase().trim()));

    return (
        <>
            {/* {!isSmallScreen && (
                <div className='sidebar-container'>
                    <SideBar />
                </div>
            )} */}
            
            <div className='faq-header-container'>
                <div className='faq-header-text'>
                    Downloads & FAQs
                </div>
            </div>

            {/* Top Downloads Section */}
            <div className='downloads-section-container'>
                <div className="downloads-section">
                    <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
                        <div className='download-title' >
                            <FontAwesomeIcon icon={faDownload} size="lg" />
                            {' '}RONIN Installer Packages
                        </div>
                        <p className='download-description'>
                            Download the official RONIN software installer for your operating system
                        </p>
                        
                        {/* VMS Platform Badges */}
                        <div className='faq-header-vms-container'>
                            <div className='faq-header-vms'>
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="10" cy="10" r="9" stroke="currentColor" strokeWidth="2"/>
                                    <path d="M6 10L9 13L14 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                                <img src={vms_nx} alt="Nx Witness" style={{ width: '1.8rem', height: '1.8rem', objectFit: 'contain' }} />
                                <span>Nx Witness</span>
                            </div>                           
                            
                            <div className='faq-header-vms'>
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="10" cy="10" r="9" stroke="currentColor" strokeWidth="2"/>
                                    <path d="M6 10L9 13L14 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                                <img src={vms_milestone} alt="Milestone" style={{ width: '1.5rem', height: '1.5rem', objectFit: 'contain' }} />
                                <span>Milestone</span>
                            </div>
                            
                            <div className='faq-header-vms'>
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="10" cy="10" r="9" stroke="currentColor" strokeWidth="2"/>
                                    <path d="M6 10L9 13L14 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                                <img src={vms_avigilon} alt="Avigilon" style={{ width: '1.5rem', height: '1.5rem', objectFit: 'contain' }} />
                                <span>Avigilon</span>
                            </div>

                             <div className='faq-header-vms'>
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="10" cy="10" r="9" stroke="currentColor" strokeWidth="2"/>
                                    <path d="M6 10L9 13L14 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                                <img src={vms_wisenet} alt="Avigilon" style={{ width: '1.5rem', height: '1.5rem', objectFit: 'contain' }} />
                                <span>Wisenet Wave</span>
                            </div>

                            <div className='faq-header-vms'>
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="10" cy="10" r="9" stroke="currentColor" strokeWidth="2"/>
                                    <path d="M6 10L9 13L14 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                                <img src={vms_dw} alt="Avigilon" style={{ width: '1.5rem', height: '1.5rem', objectFit: 'contain' }} />
                                <span>DW Spectrum</span>
                            </div>

                           
                        </div>
                    </div>

                    <div className='downloads-items' >
                        {downloadPackages.map((pkg) => {
                            return (
                                <div
                                    key={`hero-${pkg.id}`}
                                    className="download-item-wrapper"
                                    style={{
                                        background: 'rgba(255, 255, 255, 0.1)',
                                        backdropFilter: 'blur(10px)',
                                        border: '1px solid rgba(255, 255, 255, 0.2)',
                                        borderRadius: '0.75rem',
                                        padding: '1rem',
                                        transition: 'all 0.3s ease',
                                        cursor: 'pointer',
                                        position: 'relative'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.background = 'rgba(255, 255, 255, 0.15)';
                                        e.currentTarget.style.transform = 'scale(1.02)';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.background = 'rgba(255, 255, 255, 0.1)';
                                        e.currentTarget.style.transform = 'scale(1)';
                                    }}
                                >
                                    
                                    <div style={{textAlign: 'right'}}>
                                    <Tooltip
                                        size='sm'
                                        placement='left-start'
                                        trigger='click'
                                        wrapperStyle={{textAlign: 'left'}}
                                        content={
                                            <>
                                                <h4 style={{ 
                                                    color: '#4A90E2', 
                                                    marginBottom: '10px', 
                                                    fontSize: '14px',
                                                    fontWeight: 'bold'
                                                }}>
                                                    {tooltipContent[pkg.id].title}
                                                </h4>
                                                <ul style={{ 
                                                    listStyle: 'none', 
                                                    padding: '0', 
                                                    margin: '0' 
                                                }}>
                                                    {tooltipContent[pkg.id].instructions.map((instruction, index) => (
                                                        <li key={index} style={{ 
                                                            marginBottom: '6px',
                                                            paddingLeft: '15px',
                                                            position: 'relative'
                                                        }}>
                                                            <span style={{
                                                                position: 'absolute',
                                                                left: '0',
                                                                color: '#4A90E2'
                                                            }}>•</span>
                                                            {instruction}
                                                        </li>
                                                    ))}
                                                </ul>
                                            </>
                                        }>
                                        <FontAwesomeIcon icon={faInfoCircle}/>
                                    </Tooltip>
                                    </div>

                                    <div style={{ 
                                        display: 'flex', 
                                        alignItems: 'center', 
                                        marginBottom: '1rem',
                                        marginRight: '40px'
                                    }}>
                                        <div className='downloads-item-icon' >
                                            <i className={pkg.icon_class} ></i>
                                        </div>
                                        <div className='downloads-item-title'>{pkg.title}                                      
                                            <p className="downloads-item-description">{pkg.description}</p>
                                        </div>
                                    </div>
                                    
                                    <div className="package-container">
                                        <p className="package-title">
                                            Package Details:
                                        </p>
                                        <ul className="package-list">
                                            <li>• Version: {pkg.version}</li>                                           
                                            <li>• Format: {pkg.format}</li>
                                        </ul>
                                    </div>

                                    {/* Render single download button for Ubuntu/Windows */}
                                    {pkg.href && (
                                        <a
                                            href={pkg.href}
                                            {...(pkg.download ? { download: true } : {})}
                                            className='downloads-item-button'                                   
                                        >
                                            <FontAwesomeIcon icon={faDownload} style={{ marginRight: '0.5rem' }} />
                                            {pkg.buttonText}
                                        </a>
                                    )}

                                    {/* Render dropdown and download button for VMS guides */}
                                    {pkg.useDropdown && (
                                        <div className='download-installer-guide-container'>
                                            {/* Dropdown selector using custom Select component */}                                           
                                            <Select
                                                value={selectedVMSGuide}
                                                onChange={handleVMSGuideChange}
                                                options={vmsGuideOptions}
                                                size="md"
                                                selectStyle={{
                                                    background: 'rgba(255, 255, 255, 0.1)',
                                                    border: '1px solid rgba(255, 255, 255, 0.3)',
                                                    borderRadius: '0.5rem',
                                                    color: '#fff',
                                                    fontSize: '0.875rem',
                                                    cursor: 'pointer',
                                                    transition: 'all 0.3s ease',
                                                    height: '100%',
                                                    minHeight: '44px',
                                                    padding: '0.75rem 1rem'
                                                }}
                                                className="vms-guide-select"
                                            />                                           

                                            {/* Download button for selected guide */}
                                            <a
                                                href={vmsGuides[selectedVMSGuide].href}
                                                download
                                                className='downloads-item-button'
                                                style={{
                                                    flex: '1',
                                                    textAlign: 'center',
                                                    padding: '0.75rem 0.1rem',
                                                    fontSize: '0.875rem',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    gap: '0.35rem',
                                                    minWidth: '0',
                                                    whiteSpace: 'nowrap',
                                                    overflow: 'hidden',
                                                    textOverflow: 'ellipsis'
                                                }}
                                            >
                                                <FontAwesomeIcon icon={faDownload} style={{ fontSize: '0.75rem', flexShrink: 0 }} />
                                                <img 
                                                    src={vmsGuides[selectedVMSGuide].logo} 
                                                    alt={vmsGuides[selectedVMSGuide].name} 
                                                    style={{ 
                                                        width: vmsGuides[selectedVMSGuide].name === 'Nx Witness' ? '1.2rem' : '1rem', 
                                                        height: vmsGuides[selectedVMSGuide].name === 'Nx Witness' ? '1.2rem' : '1rem', 
                                                        objectFit: 'contain',
                                                        flexShrink: 0
                                                    }} 
                                                />
                                                <span style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                                    Download
                                                </span>
                                            </a>
                                        </div>
                                    )}
                                </div>
                            );
                        })}
                    </div>
                    
                    <div className='faq-help-text'>
                        <p>
                            Need help with installation? Check our <strong>FAQs below</strong> or contact our support team.
                        </p>
                    </div>
                </div>
            </div>

            <div className='search-bar-container'>
                <div className="search-bar">
                    <Input 
                        placeholder="Search questions..." 
                        className="search-box-faq" 
                        onChange={handleSearchTerm}
                    />
                </div>
            </div>

            <div className='faq-container'>
                <div>
                    <p className='subtitle'>FAQs</p>
                    <div className='accordion-container'>
                        {filteredFAQs.length > 0 ? (
                            <Accordion defaultActiveKey="0" alwaysOpen className='accordion'>
                                {filteredFAQs.map((item, index) => (
                                    <Accordion.Item eventKey={index} key={index}>
                                        <Accordion.Header>
                                            <img src={SmallIcon} alt='small-icon' className='small-icon'></img>
                                            {item.question}
                                        </Accordion.Header>
                                        <Accordion.Body>{item.answer}</Accordion.Body>
                                    </Accordion.Item>
                                ))}
                            </Accordion>
                        ) : (
                            <p style={{color: '#ccc'}}>No results found!</p>
                        )}
                    </div>
                </div>
                
                <div className='quicklink-container'>
                    <div className='quicklink-title-mfa'>
                        <p className='subtitle'>Quick links</p>
                        {/* <a href={MFAGuide} download>Download MFA Setup Guide</a> */}
                    </div>               
                    <div className='links-container'>
                        {quickLinks.map((item) =>
                            item.links.map((link, index) => (
                                <a
                                    className='link-card'
                                    key={`${item.category}-${index}`}
                                    href={link.href}
                                    {...(link.download ? { download: true } : {})}
                                    {...(item.category === 'link' ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                >
                                    <p className='link-icon'>{link.icon}</p>
                                    <p className='link-title'>{link.label}</p>
                                    <p className='link-description'>{link.description}</p>
                                    <span className='link-arrow'>→</span>
                                </a>
                            ))
                        )}
                    </div>

                    <div className="contact-section">
                        <p className='contact-text'>Need More Help?</p>
                        <p className="support-message">
                            Can't find what you're looking for? Our support team is here to help.
                        </p>
                        <a href='/#contact-us/support' className="contact-btn">Contact Support</a>
                    </div>
                </div>
            </div>

            {/* side bar cards for small screens  */}
            {isSmallScreen && <SideBarSmallScreen/>}
            
            <div className='faq-footer'>
                <Footer url={webURL}/> 
            </div>

            <style jsx>{`
                @keyframes fadeIn {
                    from {
                        opacity: 0;
                        transform: translateY(-10px);
                    }
                    to {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }

                .download-item-wrapper {
                    position: relative;
                }

                /* Custom styling for VMS guide select */
                .vms-guide-select select {
                    width: 100%;
                }

                .vms-guide-select select:hover {
                    background: rgba(255, 255, 255, 0.15) !important;
                    border-color: rgba(255, 255, 255, 0.5) !important;
                }

                .vms-guide-select select:focus {
                    border-color: rgba(255, 255, 255, 0.5) !important;
                    background: rgba(255, 255, 255, 0.15) !important;
                    outline: none;
                }

                .vms-guide-select select option {
                    background: #1a1a2e;
                    color: #fff;
                    padding: 0.5rem;
                }

                @media (max-width: 768px) {
                    .tooltip-container {
                        width: 280px !important;
                        right: 10px !important;
                    }
                }

                /* Custom select dropdown styling for better browser compatibility */
                select option {
                    padding: 0.5rem;
                }

                select:focus {
                    border-color: rgba(255, 255, 255, 0.5);
                    background: rgba(255, 255, 255, 0.15);
                }
            `}</style>
        </>
    );
};

export default DownloadsFaq;